import React, {useState} from 'react';
import HoursHelper from "../../../../services/Menu/services/Availability/HoursHelper";
import DateService from "../../../../services/Common/Date/DateService";
import {Collapse} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {ConfigApi, ConfigHoursApi} from "../../../../services/Api/types";
import {getDayOfWeek, isTimeAllDay} from "../../../../services/Common/Date/DateHelper";
import {ReactComponent as ClockIco} from "../../../../../images/icons/clock.svg";
import {ReactComponent as ArrowBottomIco} from "../../../../../images/icons/arrow-bottom.svg";
import {ReactComponent as ArrowTopIco} from "../../../../../images/icons/arrow-top.svg";
import TodayOpeningHours from "../../../OpeningHours/TodayOpeningHours";

interface Props {
    config: ConfigApi;
    locale: string | undefined;
}

const FooterOpeningHours = ({config, locale}: Props) => {
    const {t} = useTranslation();
    const openHours = config ? HoursHelper.getOpenHours(config.hours, DateService.now()) : undefined;
    const [collapseOpenHours, setCollapseOpenHours] = useState(false);
    const groupedHours = HoursHelper.getOpenHoursGroupedByWeekday(config.hours || [], true);

    const renderOpenHoursItem = (day: string, hours: ConfigHoursApi[]) => {
        const mergedHours = HoursHelper.getMergedHourRanges(hours);

        let openDayString = getDayOfWeek(day, locale, undefined, true);
        if (mergedHours.some(h => h.day_to && h.day_to !== h.day_from)) {
            const dayTo = mergedHours.find(h => h.day_to && h.day_to !== h.day_from)?.day_to!;
            openDayString += " - " + getDayOfWeek(dayTo, locale, undefined, true);
        }

        const isToday = HoursHelper.getDayOfWeekNumber(day) === new Date().getDay();
        const isOpenNow = HoursHelper.isOpen(config.hours, DateService.now());
        const classForToday = isOpenNow ? "opening-hours-success" : "opening-hours-danger";

        return (
            <>
                <td className="pe-2 align-top">
                    <p className={`mb-0 ${isToday ? classForToday : ""}`}>{`${openDayString}:`}</p>
                </td>
                <td>
                    {
                        mergedHours.length === 0 ? (
                            <p className={`mb-0 ${isToday ? classForToday : ""}`}>
                                {t("enums.store_status.closed")}
                            </p>
                        ) : (
                            mergedHours.map((h, index) => (
                                <p key={index} className={`mb-0 ${isToday ? classForToday : ""}`}>
                                    {isTimeAllDay(h.hour_from) && isTimeAllDay(h.hour_to)
                                        ? t("common.word.whole_day")
                                        : `${h.hour_from} - ${h.hour_to}`}
                                </p>
                            ))
                        )
                    }
                </td>
            </>
        );
    };

    return (
        <li>
            <div className="footer-list-item-wrapper">
                <button className={"footer-list-item"}
                        aria-expanded={collapseOpenHours}
                        aria-controls="collapse_footer_hours"
                        onClick={() => setCollapseOpenHours(!collapseOpenHours)}
                >
                    <div className={"footer-list-icon"}>
                        <ClockIco/>
                    </div>
                    <div className={"footer-list-content"}>
                        {t("common.word.now")}
                        <br/>
                        <TodayOpeningHours openHours={openHours} config={config} locale={locale}
                                           allGroupedHours={groupedHours}/>
                    </div>
                    <div className={"footer-list-action"}>
                        <div className="btn btn-sm btn-transparent btn-icon">
                            {collapseOpenHours ? <ArrowTopIco/> : <ArrowBottomIco/>}
                        </div>
                    </div>
                </button>
                <Collapse in={collapseOpenHours}>
                    <div id="collapse_footer_hours" className={"footer-open-hours"}>
                        <table>
                            <tbody>
                            {Object.entries(groupedHours).map(([day, hours]) => (
                                <tr key={day}>
                                    {renderOpenHoursItem(day, hours)}
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </Collapse>
            </div>
        </li>
    )
}

export default FooterOpeningHours;